import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { BaseComponent } from '@library-shared/base/base.component';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { spTicket_List_Selected } from '@models/StoredProcs/spTicket_List_Selected';
import { spTicket_Paid_By_Payment_ID } from '@models/StoredProcs/spTicket_Paid_By_Payment_ID';
import { tPayment } from '@models/Tables/tPayment';
import { tTicket_Session } from '@models/Tables/tTicket_Session';
import { PaymentService } from '@services/payment/payment.service';
import { SiteService } from '@services/site/site.service';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
  standalone: false,
})
export class ReceiptComponent extends BaseComponent implements OnInit, AfterViewInit {
  payment: tPayment;
  site = new spSite_Client_By_DomainX();
  ticketList: spTicket_Paid_By_Payment_ID[] = [];
  ticket: spTicket_List_Selected;

  payment_id: string;

  constructor(
    private siteService: SiteService,
    private paymentService: PaymentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  identity(): string {
    return super.identity(new tTicket_Session(this.ticket));
  }

  isMotorist(): boolean {
    return super.isMotorist(new tTicket_Session(this.ticket));
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.payment_id = params.id;
      this.loadData();
    });
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading2.set(true);

    this.paymentService.Payment_ByID({ payment_id: this.payment_id }).subscribe({
      next: (data) => {
        if (data.success) {
          this.payment = data.record;
        } else {
          this.paymentService.handleFailure(data);
        }
        this.isLoading2.set(false);
      },
    });

    this.siteService.Site_Info().subscribe({
      next: (data) => {
        this.site = data.record;
        this.paymentService.Ticket_Paid_By_Payment_ID({ payment_id: this.payment_id }).subscribe({
          next: (data2) => {
            this.ticketList = data2.records;
            this.ticket = new spTicket_List_Selected(this.ticketList.find((r) => true));
            this.isLoading2.set(false);
          },
        });
      },
    });
  }

  Search() {
    this.router.navigateByUrl('/search');
  }

  Print() {
    window.open(environment.apiURL + `/api/report/receipt?receipt_id=${this.payment.payment_id}`);
  }
}
